module.exports = __webpack_public_path__ + "img/vertical_4_1_9006.5ac153e3.png";